import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PopoutModalData } from './popout-modal.service';

export interface TooltipPopoutData extends PopoutModalData{

}

export interface TooltipHelp {
	codes: string[];
}

@Injectable({
  providedIn: 'root'
})
export class TooltipHelpService {

	isHelpOnBS: BehaviorSubject<boolean> = new BehaviorSubject(false);

	lastTooltipsBS: BehaviorSubject<TooltipHelp> = new BehaviorSubject(null);

	delayTime = 1000;

	constructor(
	) { }
	
}
